import { createRenewalTriggerFailed, createRenewalTriggerSuccess, findRenewalFailure, findRenewalSuccess, getAllRenewalTriggerFailed, getAllRenewalTriggerSuccess, getRenewalFailure, getRenewalSuccess, updateRenewalTriggerFailed, updateRenewalTriggerSuccess, whatsAppRenewalMessageSuccess, whatsAppRenewalMessageFailed } from "./action"
import { CREATE_RENEWAL_TRIGGER, FIND_RENEWAL_START, GET_RENEWAL_START, GETALL_RENEWAL_TRIGGER, UPDATE_RENEWAL_TRIGGER, WHATSAPP_RENEWAL_MESSAGE } from "./actiontypes"

import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import { createRenewalTriggerAPI, findRenewalAPI, getAllRenewalTriggerAPI, getRenewalAPI, updateRenewalTriggerAPI, whatsAppRenewalMessage } from "./api"


function* getRenewalAsync(action) {
  try {
    const response = yield call(getRenewalAPI, action.payload)
    if (response.status === 200) {
      yield put(getRenewalSuccess(response))
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(getRenewalFailure(error.response.data))

  }
}

function* createRenewal() {
  yield takeEvery(GET_RENEWAL_START, getRenewalAsync)
}


function* findRenewalAsync(action) {
  try {
    const response = yield call(findRenewalAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(findRenewalSuccess(response.data))
      console.log(response)
    } else {
      throw response;
    }
  } catch (error) {
    yield put(findRenewalFailure(error.response.data))

  }
}

function* FindRenewal() {
  yield takeEvery(FIND_RENEWAL_START, findRenewalAsync)
}


function* getAllRenewalTriggersAsync(action) {
  try {
    const response = yield call(getAllRenewalTriggerAPI, action.payload)
    if (response.status === 200) {
      yield put(getAllRenewalTriggerSuccess(response?.data?.data||[]))
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(getAllRenewalTriggerFailed(error.response.data.message || "Something unexpected error occured, please try again..."))

  }
}

function* getAllRenewalTrigger() {
  yield takeEvery(GETALL_RENEWAL_TRIGGER, getAllRenewalTriggersAsync)
}



function* createRenewalTriggersAsync(action) {
  try {
    const response = yield call(createRenewalTriggerAPI, action.payload)
    if (response.status === 200) {
      yield put(createRenewalTriggerSuccess(response?.data?.message||"Created Successfully!!!"))
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(createRenewalTriggerFailed(error.response.data.message || "Something unexpected error occured, please try again..."))

  }
}

function* createRenewalTriggers() {
  yield takeEvery(CREATE_RENEWAL_TRIGGER, createRenewalTriggersAsync)
}



function* updateRenewalTriggersAsync(action) {
  try {
    const response = yield call(updateRenewalTriggerAPI, action.payload)
    if (response.status === 200) {
      yield put(updateRenewalTriggerSuccess(response?.data?.message||"Status Updated Successfully!!!"))
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(updateRenewalTriggerFailed(error.response.data.message || "Something unexpected error occured, please try again..."))

  }
}

function* updateRenewalTriggers() {
  yield takeEvery(UPDATE_RENEWAL_TRIGGER, updateRenewalTriggersAsync)
}

function* whatsAppRenewalMessageAsync(action) {
  try {
    const response = yield call(whatsAppRenewalMessage, action.payload)

    if (response.status === 200) {
      yield put(whatsAppRenewalMessageSuccess(response?.data?.message || "Message sent successfully!"))
    } else {
      throw response
    }
  } catch (error) {
    yield put( whatsAppRenewalMessageFailed( error?.response?.data?.message || "WhatsApp send failed" ))
  }
}

function* WhatsAppMessagesend() {
  yield takeEvery(WHATSAPP_RENEWAL_MESSAGE, whatsAppRenewalMessageAsync)
}


function* RenewalSaga() {
  yield all([
    fork(createRenewal),
    fork(FindRenewal),
    fork(getAllRenewalTrigger),
    fork(createRenewalTriggers),
    fork(updateRenewalTriggers),
    fork(WhatsAppMessagesend),
  ])
}

export default RenewalSaga